export const home = {
  "Você tem assinaturas pendentes.": "Tem assinaturas pendentes.",
  "Para regulariza-las baixe o aplicativo da MarQ. e faça as solicitações.": "Para as regularizar, descarregue a aplicação da MarQ. e faça os pedidos.",
  "Baixe agora.": "Descarregue agora.",
  "Você tem uma admissão online em aberto.": "Tem uma admissão online em aberto.",
  "Para regulariza-la baixe o aplicativo da MarQ. e faça as solicitações.": "Para a regularizar, descarregue a aplicação da MarQ. e faça os pedidos.",
  "Que tal relembrar ": "Que tal relembrar ",
  "os seus momentos": "os seus momentos",
  "com a gente?": "connosco?",
  "Relembrar o meu ano": "Relembrar o meu ano",
  "Retro": "Retro",
  "Você está em regime de sobreaviso": "Está em regime de prevenção",
  "Hora de início do regime:": "Hora de início do regime:",
  "Hora de término do regime:": "Hora de término do regime:",
  "Hora:": "Hora:",
  "Último ponto registrado:": "Último ponto registado:",
  "Nenhum ponto registrado": "Nenhum ponto registado",
  "Horas faltantes": "Horas em falta",
  "Jornada Completa": "Jornada Completa",
  "Ver detalhes de hoje": "Ver detalhes de hoje",
  "Ponto em processamento": "Ponto em processamento",
  "Seu ponto das": "O seu ponto das",
  "já foi registrado!": "já foi registado!",
  "Atualize a página para visualizar o ponto.": "Atualize a página para visualizar o ponto.",
  "Atualizar página": "Atualizar página",
  "Pausa iniciada em:": "Pausa iniciada em:",
  "Você está em": "Está em",
  "pausa": "pausa",
  "Voltar da pausa": "Voltar da pausa",
  "Saldo de horas": "Saldo de horas",
  "Saldo acumulado desde": "Saldo acumulado desde",
  "Não lido": "Não lido",
  "Detalhes": "Detalhes",
  "Reuniões 1:1": "Reuniões 1:1",
  "Confira suas reuniões 1:1 agendadas, após o término, não se esqueça de avaliá-las.": "Confira as suas reuniões 1:1 agendadas, após o término, não se esqueça de as avaliar.",
  "Novo lembrete": "Novo lembrete",
  "Você tem um novo lembrete, clique aqui para ver os detalhes.": "Tem um novo lembrete, clique aqui para ver os detalhes.",
  "Tarefas pendentes": "Tarefas pendentes",
  "Você tem tarefas pendentes em seu nome, clique aqui para ver os detalhes": "Tem tarefas pendentes em seu nome, clique aqui para ver os detalhes",
  "Últimos 10 dias": "Últimos 10 dias",
  "Ver histórico": "Ver histórico",
  "Data": "Data",
  "Trabalhado": "Trabalhado",
  "Saldo": "Saldo",
  "Status": "Estado",
  "Nenhum registro": "Nenhum registo",
  "Comunicados": "Comunicados",
  "Ver todos": "Ver todos",
  "Nenhum comunicado": "Nenhum comunicado",
  "Novo comunicado": "Novo comunicado",
  "Assinatura": "Assinatura",
  "Você tem uma assinatura pendente, abra para regularizar a solicitação.": "Tem uma assinatura pendente, abra para regularizar o pedido.",
  "Novo chat": "Novo chat",
  "Você tem uma nova mensagem no chat clique para ver a mensagem": "Tem uma nova mensagem no chat, clique para ver a mensagem",
  "Admissão online": "Admissão online",
  "Preencha aqui as informações necessárias de admissão": "Preencha aqui as informações necessárias para a admissão",
  "Chegou um feedback": "Chegou um feedback",
  "Você tem um novo Feedback, veja o que estão sentindo do seu trabalho": "Tem um novo Feedback, veja o que estão a sentir sobre o seu trabalho",
  "Envio de documento": "Envio de documento",
  "Você tem um ou mais documentos pendentes para serem enviados": "Tem um ou mais documentos pendentes para serem enviados",
  "Espelho ponto": "Espelho de ponto",
  "Você tem um ou mais espelhos de ponto para serem assinados": "Tem um ou mais espelhos de ponto para serem assinados",
  "Ocorrências": "Ocorrências",
  "Solicite os ajustes necessários para resolver as suas ocorrências": "Solicite os ajustes necessários para resolver as suas ocorrências",
  "GET_MY_TEAMS": "GET_MY_TEAMS",
  "realodPage": "realodPage",
  "Férias": "Férias",
  "Afastamento": "Afastamento",
  "Solicitado": "Solicitado",
  "Aprovado": "Aprovado",
  "Recusado": "Recusado",
  "Concluído": "Concluído",
  "Ocorrência": "Ocorrência",
  "Falta": "Falta",
  "Dia atual": "Dia atual",
  "Fechar": "Fechar",
  "Admissão": "Admissão",
  "Este é o horário oficial central e pode estar diferente do horário do seu computador.": "Este é o horário oficial central e pode ser diferente do horário do seu computador.",
  "dica de ferramenta": "dica de ferramenta",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor.": "Em caso de dúvidas sobre o seu saldo, entre em contacto com o seu RH ou Gestor.",
  "Em caso de dúvidas sobre seu saldo, entre em contato com seu RH ou Gestor. Última atualização do histórico de dias foi feita no dia": "Em caso de dúvidas sobre o seu saldo, entre em contacto com o seu RH ou Gestor. A última atualização do histórico de dias foi feita no dia",
  "Última atualização dos comunicados foi feita no dia": "A última atualização dos comunicados foi feita no dia"
};


// WEBPACK FOOTER //
// ./src/resources/ptPT/home.js